import { PageHeader } from "@/components/PageHeader";
import { SEO } from "@/components/SEO";
import { site } from "@/content/site";

export function ContactPage() {
  return (
    <>
      <SEO
        title="Contact"
        description="Contact Membertou Boxing Club. Call 902.217.6694 or email boxingclub@membertou.ca. Located at 113 Membertou Street, Membertou, NS."
        path="/contact"
      />

      <PageHeader
        eyebrow="Contact"
        title="Get in the Ring"
        intro="We'd love to hear from you. Reach out by phone, email, or stop by the club."
      />

      {/* Contact info + Location — two columns */}
      <section className="section section-white texture-light" aria-labelledby="contact-heading">
        <div className="container-page py-16 sm:py-24 lg:py-32">
          <h2 id="contact-heading" className="sr-only">Contact information</h2>

          <div className="grid gap-12 lg:gap-16 lg:grid-cols-[2fr_1fr] items-start">

            {/* Left column — phone, email, names (2/3) */}
            <div>
              <a
                href={site.contact.phoneHref}
                className="block no-underline"
                style={{ color: "#0a0a0a" }}
              >
                <span
                  className="font-display uppercase block"
                  style={{
                    fontSize: "clamp(3rem, 8vw, 6rem)",
                    lineHeight: 1,
                    letterSpacing: "0.04em",
                  }}
                >
                  {site.contact.phone}
                </span>
              </a>

              <div
                aria-hidden="true"
                className="my-8"
                style={{ width: 48, height: 4, backgroundColor: "#d71920" }}
              />

              <span
                className="font-display uppercase"
                style={{
                  fontSize: "clamp(1.25rem, 3vw, 2rem)",
                  letterSpacing: "0.08em",
                  color: "#d71920",
                }}
              >
                {site.contact.email}
              </span>

              <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center gap-6 sm:gap-10">
                <p className="font-display text-lg sm:text-xl uppercase tracking-wide" style={{ color: "#0a0a0a" }}>
                  Greg Martin
                </p>
                <span
                  aria-hidden="true"
                  className="hidden sm:block"
                  style={{ width: 3, height: 24, backgroundColor: "#d71920" }}
                />
                <p className="font-display text-lg sm:text-xl uppercase tracking-wide" style={{ color: "#0a0a0a" }}>
                  Daniel Martin
                </p>
              </div>
            </div>

            {/* Right column — location (1/3) */}
            <div
              className="lg:border-l lg:pl-16"
              style={{ borderColor: "rgba(10,10,10,0.1)" }}
              aria-labelledby="location-heading"
            >
              <span className="eyebrow">Location</span>
              <h3
                id="location-heading"
                className="mt-3 text-2xl font-display uppercase tracking-wide"
              >
                Come See Us
              </h3>

              <address
                className="not-italic mt-6 text-lg leading-relaxed"
                style={{ color: "#0a0a0a" }}
              >
                <p>{site.contact.address.street}</p>
                <p>{site.contact.address.cityRegion}</p>
              </address>

              <div className="mt-6">
                <a
                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                    site.contact.address.mapsQuery,
                  )}`}
                  target="_blank"
                  rel="noreferrer noopener"
                  className="text-sm font-bold uppercase tracking-widest"
                  style={{ color: "#d71920" }}
                >
                  Open in Google Maps
                  <span className="sr-only"> (opens in a new tab)</span>
                  {" "}→
                </a>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Follow Us — red background */}
      <section
        className="relative overflow-hidden"
        style={{ backgroundColor: "#d71920", color: "#fff" }}
        aria-labelledby="social-heading"
      >
        <div className="container-page py-14 sm:py-20 text-center flex flex-col items-center gap-5">
          <span className="eyebrow before:hidden" style={{ color: "#fff" }}>Follow Us</span>
          <h2
            id="social-heading"
            className="mt-1"
            style={{ fontSize: "clamp(1.75rem, 4vw, 2.75rem)" }}
          >
            Stay Connected
          </h2>
          <p
            className="text-lg max-w-prose mx-auto"
            style={{ color: "rgba(255,255,255,0.9)" }}
          >
            Follow the club on Facebook for news, training updates, and event announcements.
          </p>
          <div className="mt-2">
            <a
              href={site.contact.facebookHref}
              target="_blank"
              rel="noreferrer noopener"
              className="btn-on-red"
            >
              Membertou Boxing Club on Facebook
              <span className="sr-only"> (opens in a new tab)</span>
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
